import { ApiError, ApiErrorCode } from '@bustickus/api';
import { RoutingUrls } from 'common/const';

function procceedError(e: Error, redirectToAuth: boolean) {
  if (e instanceof ApiError && e.code === ApiErrorCode.BadRequest) {
    window.location.href = RoutingUrls.Error.replace(':code?', '400');
  } else if (e instanceof ApiError && e.code === ApiErrorCode.Conflict) {
    window.location.href = RoutingUrls.Error.replace(':code?', '400');
  } else if (e instanceof ApiError && e.code === ApiErrorCode.Unauthorized) {
    if (redirectToAuth) {
      window.location.href = RoutingUrls.Auth;
    } else {
      window.location.href = RoutingUrls.Error.replace(':code?', '401');
    }
  } else if (e instanceof ApiError && e.code === ApiErrorCode.Forbidden) {
    if (redirectToAuth) {
      window.location.href = RoutingUrls.Auth;
    } else {
      window.location.href = RoutingUrls.Error.replace(':code?', '401');
    }
  } else if (e instanceof ApiError && e.code === ApiErrorCode.NotFound) {
    window.location.href = RoutingUrls.Error.replace(':code?', '404');
  } else {
    window.location.href = RoutingUrls.Error.replace(':code?', '');
  }
}

export default procceedError;
